<template>
  <a-modal
    title="地图选点"
    :visible="visible"
    :width="1000"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-row :gutter="16">
      <a-col :span="16">
        <div id="mapPickerContainer" style="width: 100%; height: 500px"></div>
      </a-col>
      <a-col :span="8">
        <div style="margin-bottom: 12px">
          <a-input-search
            v-model:value="searchKeyword"
            placeholder="搜索地点名称"
            @search="handleSearch"
            @pressEnter="handleSearch"
            allow-clear
          >
            <template v-slot:enterButton>
              <a-button type="primary" class="search-btn">
                <SearchOutlined />搜索
              </a-button>
            </template>
          </a-input-search>
        </div>
        <div
          style="
            max-height: 300px;
            overflow-y: auto;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 8px;
          "
        >
          <div
            v-if="searchResults.length === 0 && !searching"
            style="text-align: center; color: #999; padding: 20px"
          >
            请输入地点名称进行搜索
          </div>
          <a-spin :spinning="searching" tip="搜索中...">
            <div
              v-for="(item, index) in searchResults"
              :key="index"
              @click="selectSearchResult(item)"
              style="
                padding: 8px;
                cursor: pointer;
                border-bottom: 1px solid #f0f0f0;
                transition: background 0.3s;
              "
              :style="{
                background: selectedResultIndex === index ? '#e6f7ff' : '#fff',
              }"
              @mouseenter="$event.target.style.background = '#f5f5f5'"
              @mouseleave="
                $event.target.style.background =
                  selectedResultIndex === index ? '#e6f7ff' : '#fff'
              "
            >
              <div style="font-weight: 500; color: #1890ff; margin-bottom: 4px">
                {{ item.name }}
              </div>
              <div style="font-size: 12px; color: #666">
                {{ item.address || item.district }}
              </div>
            </div>
          </a-spin>
        </div>
      </a-col>
    </a-row>
    <div style="margin-top: 16px">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-input-group compact>
            <a-input
              addon-before="经度"
              v-model:value="selectedLng"
              readonly
              style="width: calc(100% - 60px)"
            />
          </a-input-group>
        </a-col>
        <a-col :span="12">
          <a-input-group compact>
            <a-input
              addon-before="纬度"
              v-model:value="selectedLat"
              readonly
              style="width: calc(100% - 60px)"
            />
          </a-input-group>
        </a-col>
      </a-row>
      <a-input
        v-model:value="selectedAddress"
        placeholder="详细地址"
        readonly
        style="margin-top: 12px"
      />
      <a-input
        v-model:value="selectedDetailAddress"
        placeholder="完整地址信息"
        type="textarea"
        :rows="2"
        readonly
        style="margin-top: 12px"
      />
      <div style="margin-top: 16px; text-align: right">
        <a-button @click="handleCancel" class="cancel-btn" style="margin-right: 8px"
          >取消</a-button
        >
        <a-button type="primary" @click="handleConfirm" class="confirm-btn">确认选择</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { SearchOutlined } from '@ant-design/icons-vue'
export default {
  name: 'MapPicker',
  components: {
    SearchOutlined,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    longitude: {
      type: [String, Number],
      default: null,
    },
    latitude: {
      type: [String, Number],
      default: null,
    },
    address: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      placeSearch: null,
      selectedLng: '',
      selectedLat: '',
      selectedAddress: '',
      selectedDetailAddress: '',
      searchKeyword: '',
      searchResults: [],
      searching: false,
      selectedResultIndex: -1,
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initSelectedValues()
        this.$nextTick(() => {
          this.loadAmapScript()
            .then(() => {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.initMap()
                }, 200)
              })
            })
            .catch((error) => {
              console.error('地图加载错误:', error)
              this.$message.error(
                error.message || '地图加载失败，请检查网络连接或配置高德地图Key'
              )
            })
        })
      } else {
        this.destroyMap()
      }
    },
  },
  methods: {
    // 初始化选中值
    initSelectedValues() {
      if (this.longitude && this.latitude) {
        this.selectedLng = String(this.longitude)
        this.selectedLat = String(this.latitude)
        this.selectedAddress = this.address || ''
        this.selectedDetailAddress = this.address || ''
      } else {
        this.selectedLng = ''
        this.selectedLat = ''
        this.selectedAddress = ''
        this.selectedDetailAddress = ''
      }
      this.searchKeyword = ''
      this.searchResults = []
      this.selectedResultIndex = -1
      this.searching = false
    },
    // 加载高德地图脚本
    loadAmapScript() {
      // 如果已经加载过，直接返回
      if (window.AMap && window.AMap.Map) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        // 高德地图Key，请替换为您的实际Key
        // 可以从环境变量或配置文件中读取：process.env.VUE_APP_AMAP_KEY
        const amapKey = process.env.VUE_APP_AMAP_KEY || 'YOUR_AMAP_KEY'

        // 检查是否已经有脚本标签
        const existingScript = document.querySelector(
          'script[src*="webapi.amap.com"]'
        )
        if (existingScript) {
          // 如果脚本已存在，等待加载完成
          const checkInterval = setInterval(() => {
            if (window.AMap && window.AMap.Map) {
              clearInterval(checkInterval)
              resolve()
            }
          }, 100)

          // 10秒超时
          setTimeout(() => {
            clearInterval(checkInterval)
            if (!window.AMap || !window.AMap.Map) {
              reject(
                new Error('高德地图加载超时，请检查网络连接或配置高德地图Key')
              )
            }
          }, 10000)
          return
        }

        const script = document.createElement('script')
        script.type = 'text/javascript'

        script.onerror = () => {
          reject(new Error('高德地图加载失败，请检查网络连接或配置高德地图Key'))
        }

        // 使用唯一回调名，避免多次加载冲突
        const callbackName = 'initAMap_' + Date.now()
        window[callbackName] = () => {
          // 确保AMap对象已完全加载
          if (window.AMap && window.AMap.Map) {
            delete window[callbackName]
            resolve()
          } else {
            reject(new Error('高德地图初始化失败'))
          }
        }

        script.src = `https://webapi.amap.com/maps?v=1.4.15&key=${amapKey}&plugin=AMap.PlaceSearch,AMap.Geocoder&callback=${callbackName}`
        script.async = true
        document.head.appendChild(script)
      })
    },
    // 初始化地图
    initMap() {
      const container = document.getElementById('mapPickerContainer')
      if (!container) {
        console.error('地图容器不存在')
        return
      }

      // 如果地图已存在，先销毁
      if (this.map) {
        try {
          this.map.destroy()
        } catch (e) {
          console.warn('销毁地图时出错:', e)
        }
        this.map = null
        this.marker = null
      }

      // 检查AMap是否已加载
      if (!window.AMap || !window.AMap.Map) {
        console.error('高德地图API未加载')
        this.$message.error('高德地图API未加载，请刷新页面重试')
        return
      }

      try {
        // 如果有已有经纬度，使用已有位置，否则使用默认位置（北京）
        const center =
          this.longitude && this.latitude
            ? [parseFloat(this.longitude), parseFloat(this.latitude)]
            : [116.397428, 39.90923]

        this.map = new window.AMap.Map('mapPickerContainer', {
          zoom: 13,
          center: center,
          mapStyle: 'amap://styles/normal',
          viewMode: '2D',
        })

        // 等待地图加载完成
        this.map.on('complete', () => {
          // 初始化地点搜索服务
          try {
            this.placeSearch = new window.AMap.PlaceSearch({
              city: '全国',
              citylimit: false,
              pageSize: 10,
              pageIndex: 1,
            })
          } catch (e) {
            console.error('初始化搜索服务失败:', e)
            this.$message.warning('搜索功能初始化失败，但地图可以正常使用')
          }

          // 如果已有经纬度，添加标记
          if (this.longitude && this.latitude) {
            this.addMarker(center)
            this.getAddressByLngLat(center)
          }
        })

        // 地图点击事件
        this.map.on('click', (e) => {
          const lng = e.lnglat.getLng()
          const lat = e.lnglat.getLat()
          this.selectedLng = lng.toFixed(6)
          this.selectedLat = lat.toFixed(6)
          this.addMarker([lng, lat])
          this.getAddressByLngLat([lng, lat])
          this.selectedResultIndex = -1
        })
      } catch (error) {
        console.error('初始化地图失败:', error)
        this.$message.error('地图初始化失败: ' + (error.message || '未知错误'))
      }
    },
    // 搜索地点
    handleSearch() {
      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        this.$message.warning('请输入搜索关键词')
        return
      }

      if (!this.placeSearch) {
        this.$message.error('搜索服务未初始化')
        return
      }

      this.searching = true
      this.searchResults = []
      this.selectedResultIndex = -1

      this.placeSearch.search(this.searchKeyword, (status, result) => {
        this.searching = false
        if (status === 'complete' && result.info === 'OK') {
          this.searchResults = result.poiList.pois.map((poi) => ({
            name: poi.name,
            address: poi.address,
            district: poi.district,
            location: poi.location,
            tel: poi.tel,
            type: poi.type,
            fullAddress: poi.address
              ? `${poi.district}${poi.address}`
              : poi.district,
          }))
          if (this.searchResults.length === 0) {
            this.$message.info('未找到相关地点')
          }
        } else {
          this.$message.error('搜索失败，请重试')
        }
      })
    },
    // 选择搜索结果
    selectSearchResult(item) {
      const location = item.location
      const lng = location.lng
      const lat = location.lat

      this.selectedLng = lng.toFixed(6)
      this.selectedLat = lat.toFixed(6)
      this.selectedAddress = item.address || item.district
      this.selectedDetailAddress =
        item.fullAddress || item.address || item.district

      // 定位到选择的位置
      const position = [lng, lat]
      this.addMarker(position)
      this.map.setCenter(position)
      this.map.setZoom(16)

      // 获取详细地址信息
      this.getAddressByLngLat(position, item)

      // 高亮选中的结果
      this.selectedResultIndex = this.searchResults.findIndex(
        (r) =>
          r.name === item.name &&
          r.location.lng === lng &&
          r.location.lat === lat
      )
    },
    // 添加标记
    addMarker(position) {
      if (this.marker) {
        this.marker.setPosition(position)
      } else {
        this.marker = new window.AMap.Marker({
          position: position,
          draggable: true,
        })
        this.map.add(this.marker)

        // 标记拖拽事件
        this.marker.on('dragend', (e) => {
          const lng = e.lnglat.getLng()
          const lat = e.lnglat.getLat()
          this.selectedLng = lng.toFixed(6)
          this.selectedLat = lat.toFixed(6)
          this.getAddressByLngLat([lng, lat])
        })
      }
      this.map.setCenter(position)
    },
    // 根据经纬度获取地址（逆地理编码）
    getAddressByLngLat(position, searchItem = null) {
      const geocoder = new window.AMap.Geocoder({
        city: '全国',
        radius: 1000,
      })
      geocoder.getAddress(position, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          const regeocode = result.regeocode
          // 如果是从搜索结果选择的，使用搜索结果的地址信息
          if (searchItem) {
            this.selectedAddress =
              searchItem.address || regeocode.formattedAddress
            // 构建完整地址信息：省市区 + 街道 + 详细地址
            const addressComponent = regeocode.addressComponent
            let fullAddress = ''
            if (addressComponent.province) {
              fullAddress += addressComponent.province
            }
            if (addressComponent.city) {
              fullAddress += addressComponent.city
            }
            if (addressComponent.district) {
              fullAddress += addressComponent.district
            }
            if (addressComponent.township) {
              fullAddress += addressComponent.township
            }
            if (addressComponent.street) {
              fullAddress += addressComponent.street
            }
            if (addressComponent.streetNumber) {
              fullAddress += addressComponent.streetNumber
            }
            if (
              regeocode.formattedAddress &&
              regeocode.formattedAddress !== fullAddress
            ) {
              fullAddress = regeocode.formattedAddress
            }
            this.selectedDetailAddress =
              fullAddress ||
              searchItem.fullAddress ||
              regeocode.formattedAddress
          } else {
            // 直接点击地图获取的地址
            this.selectedAddress = regeocode.formattedAddress
            const addressComponent = regeocode.addressComponent
            let fullAddress = ''
            if (addressComponent.province) {
              fullAddress += addressComponent.province
            }
            if (addressComponent.city) {
              fullAddress += addressComponent.city
            }
            if (addressComponent.district) {
              fullAddress += addressComponent.district
            }
            if (addressComponent.township) {
              fullAddress += addressComponent.township
            }
            if (addressComponent.street) {
              fullAddress += addressComponent.street
            }
            if (addressComponent.streetNumber) {
              fullAddress += addressComponent.streetNumber
            }
            this.selectedDetailAddress =
              fullAddress || regeocode.formattedAddress
          }
        } else {
          this.selectedAddress = searchItem
            ? searchItem.address || '地址解析失败'
            : '地址解析失败'
          this.selectedDetailAddress = searchItem
            ? searchItem.fullAddress || '地址解析失败'
            : '地址解析失败'
        }
      })
    },
    // 确认选择位置
    handleConfirm() {
      if (!this.selectedLng || !this.selectedLat) {
        this.$message.warning('请先在地图上选择位置或搜索选择地点')
        return
      }
      // 触发确认事件，传递选择的数据
      $emit(this, 'confirm', {
        longitude: this.selectedLng,
        latitude: this.selectedLat,
        address: this.selectedDetailAddress || this.selectedAddress,
      })
      this.$message.success('位置已选择')
    },
    // 取消选择
    handleCancel() {
      $emit(this, 'cancel')
    },
    // 销毁地图
    destroyMap() {
      if (this.map) {
        try {
          this.map.destroy()
        } catch (e) {
          console.warn('销毁地图时出错:', e)
        }
        this.map = null
        this.marker = null
      }
      if (this.placeSearch) {
        this.placeSearch = null
      }
    },
  },
  beforeUnmount() {
    this.destroyMap()
  },
  emits: ['confirm', 'cancel'],
}
</script>

<style scoped>
/* 输入框圆角 */
:deep(.ant-input),
:deep(.ant-input:hover),
:deep(.ant-input:focus),
:deep(.ant-input-search .ant-input),
:deep(.ant-input-search .ant-input:hover),
:deep(.ant-input-search .ant-input:focus),
:deep(.ant-input-group .ant-input),
:deep(.ant-input-group .ant-input:hover),
:deep(.ant-input-group .ant-input:focus) {
  border-radius: 4px !important;
}

:deep(.ant-input-affix-wrapper),
:deep(.ant-input-affix-wrapper:hover),
:deep(.ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
}

/* 搜索按钮样式 */
.search-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.search-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.search-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.search-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

/* 确认按钮样式 */
.confirm-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.confirm-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.confirm-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.confirm-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

/* 取消按钮样式 */
.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

/* 所有 primary 按钮样式 */
:deep(.ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

:deep(.ant-btn-primary:hover) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

:deep(.ant-btn-primary:focus) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

:deep(.ant-btn-primary:active) {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}
</style>
